import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import type { TemporaryStep } from './steps.types';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { Group } from '@bugbug/core/types/groups';
import type { Step } from '@bugbug/core/types/steps';

import { testsApi } from '../tests/tests.api';

import { stepsApi } from './steps.api';

interface StepsState {
  currentStep?: Pick<Step | TemporaryStep, 'id' | 'groupId'> & { isTemporary?: boolean };
}

const initialState: StepsState = {};

const StepsSlice = createSlice({
  name: 'steps',
  initialState,

  reducers: {
    resetCurrentStep(state) {
      state.currentStep = undefined;
    },

    setCurrentStep(
      state,
      action: PayloadAction<{
        id: Step['id'];
        groupId: Step['groupId'];
      }>,
    ) {
      state.currentStep = action.payload;
    },

    toggleCurrentStep(
      state,
      action: PayloadAction<{
        id: Step['id'];
        groupId: Group['id'];
      }>,
    ) {
      const { id, groupId } = action.payload;
      state.currentStep =
        state.currentStep?.id === id && state.currentStep?.groupId === groupId
          ? undefined
          : action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addMatcher(stepsApi.endpoints.createStep.matchFulfilled, (state, action) => {
        if (state.currentStep?.isTemporary) {
          state.currentStep = action.payload;
        }
      })
      .addMatcher(
        isAnyOf(
          testsApi.endpoints.getCurrentTest.matchFulfilled,
          testsApi.endpoints.clearTest.matchFulfilled,
        ),
        (state) => {
          state.currentStep = undefined;
        },
      );
  },
});

export const StepsActions = StepsSlice.actions;

export default StepsSlice.reducer;
